import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../library/assets/Search.svg'
import _imports_1 from '../library/assets/Close_square.png'
import _imports_2 from '../library/assets/User_alt.png'
import _imports_3 from '../library/assets/Favorite.png'
import _imports_4 from '../library/assets/cart.png'
import _imports_5 from '../library/assets/gold-cart.png'
import _imports_6 from '../library/assets/Trash.png'
import _imports_7 from '@/assets/icons/directory.svg'


const _withScopeId = n => (_pushScopeId("data-v-2ec68e94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asahi-bs-header navbar sticky-top" }
const _hoisted_2 = { class: "asahi-bs-header-upper" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row flex-fill flex-nowrap align-items-center" }
const _hoisted_5 = { class: "col-auto header-back" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-auto logo-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "col col-lg-auto"
}
const _hoisted_9 = { class: "row g-0" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "d-flex d-lg-none"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3 breadcrumb-catalogue" }, "/", -1))
const _hoisted_13 = {
  key: 3,
  class: "asahi-menu-name"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Search-icon",
  src: _imports_0
}, null, -1))
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "asahi-cancel-container"
}
const _hoisted_17 = {
  key: 0,
  class: "row align-items-center"
}
const _hoisted_18 = { class: "col-auto" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "user",
  src: _imports_2
}, null, -1))
const _hoisted_20 = { class: "col-auto" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "favorite",
  src: _imports_3
}, null, -1))
const _hoisted_22 = { class: "col-auto" }
const _hoisted_23 = { class: "asahi-quantity-cart-container" }
const _hoisted_24 = {
  key: 0,
  alt: "cart",
  class: "asahi-address-icon",
  src: _imports_4
}
const _hoisted_25 = {
  key: 1,
  alt: "address",
  class: "asahi-address-icon",
  src: _imports_5
}
const _hoisted_26 = {
  key: 2,
  class: "asahi-cart-quantity"
}
const _hoisted_27 = { class: "asahi-container" }
const _hoisted_28 = {
  key: 0,
  class: "asahi-product-container"
}
const _hoisted_29 = { class: "asahi-label-container" }
const _hoisted_30 = ["href", "onClick"]
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 0,
  class: "asahi-quantity-container"
}
const _hoisted_33 = {
  key: 0,
  class: "asahi-quantity-item"
}
const _hoisted_34 = { class: "asahi-unit" }
const _hoisted_35 = { class: "asahi-unit text-capitalize" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 1,
  class: "asahi-quantity-item"
}
const _hoisted_39 = { class: "asahi-unit" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "trash-icon",
  class: "asahi-trash-icon",
  src: _imports_6
}, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 1,
  class: "asahi-cart-buttons-container"
}
const _hoisted_44 = { class: "asahi-remove-container" }
const _hoisted_45 = { class: "asahi-cancel" }
const _hoisted_46 = { class: "asahi-remove-container" }
const _hoisted_47 = { class: "asahi-go-to-cart" }
const _hoisted_48 = { class: "asahi-bs-header-lower hidden-lg-up" }
const _hoisted_49 = { class: "container-fluid" }
const _hoisted_50 = { class: "row align-items-center" }
const _hoisted_51 = { class: "col" }
const _hoisted_52 = {
  key: 1,
  class: "asahi-search-results"
}
const _hoisted_53 = {
  key: 0,
  class: "text-center mt-3 fw-bold"
}
const _hoisted_54 = {
  key: 2,
  class: "container my-5"
}
const _hoisted_55 = { class: "row justify-content-center" }
const _hoisted_56 = { class: "col-12 col-lg-10" }
const _hoisted_57 = {
  key: 0,
  class: "asahi-history"
}
const _hoisted_58 = { class: "asahi-search-results-container" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "asahi-search-results-container" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = { class: "asahi-search-results-container" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = {
  key: 0,
  class: "asahi-search-results-item"
}
const _hoisted_67 = { class: "asahi-search-results-item-img" }
const _hoisted_68 = ["src"]
const _hoisted_69 = {
  key: 1,
  alt: "placeholder",
  src: _imports_7
}
const _hoisted_70 = ["innerHTML"]
const _hoisted_71 = {
  key: 2,
  class: "fw-bold d-flex justify-content-center mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AsahiToast = _resolveComponent("AsahiToast")!
  const _component_AsahiLogoNew = _resolveComponent("AsahiLogoNew")!
  const _component_drop_down = _resolveComponent("drop-down")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_AsahiUserIcon = _resolveComponent("AsahiUserIcon")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_AsahiFavoriteIcon = _resolveComponent("AsahiFavoriteIcon")!
  const _component_AsahiSelect = _resolveComponent("AsahiSelect")!
  const _component_AsahiLoaderCard = _resolveComponent("AsahiLoaderCard")!
  const _component_AsahiHistoryIcon = _resolveComponent("AsahiHistoryIcon")!
  const _component_AsahiTabs = _resolveComponent("AsahiTabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showToast)
      ? (_openBlock(), _createBlock(_component_AsahiToast, {
          key: 0,
          class: "toast-container",
          isToastVisible: _ctx.showToast,
          onHideToast: _ctx.hideToast,
          delayHide: 2000
        }, {
          body: _withCtx(() => [
            (_ctx.firstMessage.length > 0)
              ? (_openBlock(), _createBlock(_component_AsahiTypography, {
                  key: 0,
                  type: "headline-small",
                  class: "me-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.firstMessage), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_AsahiTypography, {
              type: "headline-2",
              class: "me-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.showToastDetails.productName), 1)
              ]),
              _: 1
            }),
            (_ctx.showToastMessage.length > 0)
              ? (_openBlock(), _createBlock(_component_AsahiTypography, {
                  key: 1,
                  type: "headline-small",
                  class: "me-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.showToastMessage), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, { to: "/cart" }, {
              default: _withCtx(() => [
                _createVNode(_component_AsahiTypography, {
                  type: "headline-2",
                  class: "primary-gold me-2 text-decoration-underline"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('your cart')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["isToastVisible", "onHideToast"]))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.chevronLeft,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_AsahiLogoNew, {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.navigateToPath({name: 'Logo', label: 'Logo', link: '/' })), ["prevent"]))
              })
            ]),
            (!_ctx.searchActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerData, (value) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["col col-lg-auto cta-wrapper", [value.name === 'Create an order' ? '' : 'hidden-lg-down']]),
                        key: value
                      }, [
                        (value.name !== 'Create an order' && value.name !== 'products_catalogue')
                          ? (_openBlock(), _createBlock(_component_drop_down, {
                              "dropdown-name": value.label,
                              key: value,
                              options: value.children,
                              "type-color": value.name === 'Create an order' ? '#9F8852' : '#1A3E13',
                              "text-color": value.name === 'Create an order' ? 'white' : 'default',
                              "border-type": value.name === 'Create an order' ? '0px' : 'default',
                              "icon-type": value.name === 'Create an order' ? 'gold' : 'white',
                              type: 'text',
                              "routing-path": _ctx.getRoutingPath(value.children, value.name)
                            }, null, 8, ["dropdown-name", "options", "type-color", "text-color", "border-type", "icon-type", "routing-path"]))
                          : _createCommentVNode("", true),
                        (value.name === 'Create an order' && !_ctx.hideCta)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_router_link, {
                                to: _ctx.getRoutingPath(value.children, value.name),
                                onClick: _withModifiers(($event: any) => (_ctx.navigateToPath({name: value.name, label: value.name, link: _ctx.getRoutingPath(value.children, value.name) })), ["prevent"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_AsahiButton, {
                                    class: "'add-to-cart'",
                                    type: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(value.label), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["to", "onClick"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.showCtaCatalog)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _hoisted_12,
                              _createVNode(_component_router_link, {
                                to: _ctx.getRoutingPath(value.children, value.name),
                                onClick: _withModifiers(($event: any) => (_ctx.navigateToPath({name: value.name, label: value.name, link: _ctx.getRoutingPath(value.children, value.name) })), ["prevent"]),
                                class: "breadcrumb-catalogue text-decoration-underline"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('Beer Catalogue')), 1)
                                ]),
                                _: 2
                              }, 1032, ["to", "onClick"])
                            ]))
                          : _createCommentVNode("", true),
                        (value.name === 'products_catalogue')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_router_link, {
                                to: _ctx.getRoutingPath(value.children, value.name),
                                onClick: _withModifiers(($event: any) => (_ctx.navigateToPath({name: 'Products catalogue', label: 'Products catalogue', link: _ctx.getRoutingPath(value.children, value.name) })), ["prevent"]),
                                class: "menu-link"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(value.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["to", "onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["col hidden-lg-down", {'full-input-col' : _ctx.searchActive}])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["input-container", {'full-input-search': _ctx.searchActive}]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSearchOpen()))
              }, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "search-content",
                  placeholder: _ctx.searchActive ? _ctx.searchKeyword : _ctx.$t('Search'),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchValue) = $event)),
                  onKeyup: [
                    _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearchType())),
                    _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.doSearchOnEnter()), ["enter"]))
                  ]
                }, null, 40, _hoisted_15), [
                  [_vModelText, _ctx.searchValue]
                ]),
                (_ctx.searchActive)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      alt: "Close-icon",
                      class: "asahi-search-reset",
                      src: _imports_1,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSearchReset()))
                    }))
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.searchActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSearchClose())),
                      class: "asahi-cancel"
                    }, _toDisplayString(_ctx.$t('Cancel')), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-auto hidden-lg-down", [_ctx.searchActive ? 'd-none' : '']])
            }, [
              (!_ctx.searchActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_CustomButton, {
                        options: this.combinedOptions(),
                        "is-padding": true
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: "/my-profile/details",
                            onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.navigateToPath({name: 'My Profile', label: 'My Profile', link: '/my-profile/details' })), ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          })
                        ]),
                        "hover-icon": _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: "/my-profile/details",
                            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.navigateToPath({name: 'My Profile', label: 'My Profile', link: '/my-profile/details' })), ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_AsahiUserIcon)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["options"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      (_ctx.catalogPermission)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: "/catalog/favorites",
                            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.navigateToPath({name: 'Favorites', label: 'Favorites', link: '/catalog/favorites' })), ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CustomButton, {
                                "pop-up-type": 'no-pop-up',
                                "icon-quantity": _ctx.favoriteItem,
                                options: [{ href: '/catalog/favorites'}]
                              }, {
                                icon: _withCtx(() => [
                                  _hoisted_21
                                ]),
                                "hover-icon": _withCtx(() => [
                                  _createVNode(_component_AsahiFavoriteIcon)
                                ]),
                                _: 1
                              }, 8, ["icon-quantity"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      (_ctx.catalogPermission)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["asahi-cart-container", {'asahi-cart-container-open': _ctx.openCart}]),
                            onMouseover: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openCart = true)),
                            onMouseleave: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openCart = false))
                          }, [
                            _createVNode(_component_router_link, {
                              to: "/cart",
                              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.beginCheckout('/cart', 'number-items')), ["prevent"]))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_23, [
                                  (!_ctx.openCart)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_25)),
                                  (_ctx.cartNumber > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.cartNumber), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_27, [
                              (_ctx.openCart)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "asahi-items-container",
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openCart = true))
                                  }, [
                                    (_ctx.cartNumber > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItem, (items) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "asahi-cart-items",
                                              key: items
                                            }, [
                                              _createElementVNode("div", _hoisted_29, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("a", {
                                                    href: `/catalog/${items.product?.sku}`,
                                                    onClick: _withModifiers(($event: any) => (_ctx.navigateToPath({name: 'Product', label: `Cart - Product SKU: ${items.product?.sku}`, link: `/catalog/${items.product?.sku}` })), ["prevent"])
                                                  }, [
                                                    _createElementVNode("img", {
                                                      alt: "product",
                                                      class: "asahi-items-image",
                                                      src: items.product.image.url
                                                    }, null, 8, _hoisted_31)
                                                  ], 8, _hoisted_30)
                                                ]),
                                                (_ctx.isTruckAvailable)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                      _createTextVNode(_toDisplayString(items.product.catalog_product_name ? items.product.catalog_product_name : items.product.name) + " ", 1),
                                                      (!_ctx.isTruck)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                            _createElementVNode("div", _hoisted_34, [
                                                              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Units')), 1),
                                                              _createElementVNode("div", null, _toDisplayString(items.quantity_from_fe), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_35, [
                                                              (_ctx.isWHSLUser)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.$t('Layer')) + " (" + _toDisplayString(_ctx.$t('units')) + ": " + _toDisplayString(items.product.number_of_products_on_layer) + ") ", 1))
                                                                : _createCommentVNode("", true),
                                                              (_ctx.isWHSLUser)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(items.number_of_layer_from_fe), 1))
                                                                : _createCommentVNode("", true)
                                                            ])
                                                          ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                            _createElementVNode("div", _hoisted_39, [
                                                              _createElementVNode("div", null, _toDisplayString(_ctx.isTruckOnly ? _ctx.$t('Pallets') : _ctx.$t('Units')), 1),
                                                              _createElementVNode("div", null, _toDisplayString(_ctx.isTruckOnly ? items.number_of_pallet_from_fe : items.quantity_from_fe), 1)
                                                            ])
                                                          ]))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", {
                                                  onClick: ($event: any) => (_ctx.removeProductFromCart(items.id))
                                                }, _hoisted_42, 8, _hoisted_40)
                                              ])
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.cartNumber > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                          _createElementVNode("div", _hoisted_44, [
                                            _createElementVNode("div", {
                                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.removeAllCartItems && _ctx.removeAllCartItems(...args)))
                                            }, [
                                              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('Remove All')), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_46, [
                                            _createVNode(_component_router_link, {
                                              to: "/cart",
                                              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.beginCheckout('/cart', 'go-to-cart')), ["prevent"]))
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('Go To Cart')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]))
                                      : (_openBlock(), _createBlock(_component_AsahiTypography, {
                                          key: 2,
                                          type: "headline-small",
                                          color: "primary-white",
                                          class: "me-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(this.$t('The cart is Empty')), 1)
                                          ]),
                                          _: 1
                                        }))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 34))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              (_ctx.shipToList && _ctx.shipToList?.length)
                ? (_openBlock(), _createBlock(_component_AsahiSelect, {
                    key: _ctx.getSelectedShipToDetails?.shipToId,
                    shipToId: _ctx.getSelectedShipToDetails?.shipToId,
                    showOnHover: _ctx.showOnHover,
                    selectedOptionValue: _ctx.getSelectedShipToDetails?.shipToId,
                    iconUrl: _ctx.locationwhite,
                    iconUrlHover: _ctx.locationgold,
                    options: _ctx.shipToList,
                    name: "shipto",
                    showArrow: _ctx.shipToList?.length > 1
                  }, null, 8, ["shipToId", "showOnHover", "selectedOptionValue", "iconUrl", "iconUrlHover", "options", "showArrow"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.searchActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          (!_ctx.searchHistory)
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.$t('No Search History available')), 1))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_AsahiLoaderCard, { key: 1 }))
            : _createCommentVNode("", true),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    (_ctx.searchValue?.length < 3 && _ctx.searchHistory?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('Search')) + " " + _toDisplayString(_ctx.$t('History')), 1),
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHistory, (keyword) => {
                                return (_openBlock(), _createElementBlock("li", { key: keyword }, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.redoSearch(keyword))
                                  }, [
                                    _createVNode(_component_AsahiHistoryIcon),
                                    _createTextVNode(" " + _toDisplayString(keyword), 1)
                                  ], 8, _hoisted_59)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('Products')), 1),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.id,
                                  class: "col-3"
                                }, [
                                  (index < 4)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "asahi-search-results-item cursor-pointer",
                                        onClick: ($event: any) => (_ctx.navigateToProductPage(item))
                                      }, [
                                        _createElementVNode("div", {
                                          class: "asahi-search-results-item-img",
                                          style: _normalizeStyle({ backgroundImage: 'url(' + item?.small_image.url + ')' })
                                        }, null, 4),
                                        _createElementVNode("p", null, [
                                          _createElementVNode("span", {
                                            innerHTML: item?.name?.replace(RegExp('(' + _ctx.searchHistory[0] + ')', 'gi'), '<b>$1</b>')
                                          }, null, 8, _hoisted_63)
                                        ]),
                                        _createElementVNode("p", null, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('Price per packaging incl. VAT')) + " ", 1),
                                          _createElementVNode("b", null, _toDisplayString(item?.your_price_tax), 1)
                                        ])
                                      ], 8, _hoisted_62))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('Marketing materials')), 1),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marketingMaterialsFiles, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.id,
                                  class: "col-3"
                                }, [
                                  (index < 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                        _createElementVNode("div", _hoisted_67, [
                                          (item?.file?.link)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                alt: "link-img",
                                                src: item?.file?.link
                                              }, null, 8, _hoisted_68))
                                            : (_openBlock(), _createElementBlock("img", _hoisted_69))
                                        ]),
                                        _createElementVNode("p", null, [
                                          _createElementVNode("span", {
                                            innerHTML: item?.name?.replace(RegExp('(' + _ctx.searchHistory[0] + ')', 'gi'), '<b>$1</b>')
                                          }, null, 8, _hoisted_70)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.searchValue?.length >= 3 && _ctx.visibleTabs.length > 0)
                      ? (_openBlock(), _createBlock(_component_AsahiTabs, {
                          key: 1,
                          tabs: _ctx.visibleTabs,
                          currentTab: _ctx.currentTab,
                          onTabChanged: _ctx.onTabChanged,
                          searchValue: _ctx.searchValue,
                          onEmitChildMethod: _cache[17] || (_cache[17] = ($event: any) => (_ctx.searchActive = false))
                        }, null, 8, ["tabs", "currentTab", "onTabChanged", "searchValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.visibleTabs.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.$t('No Result Found')), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.searchActive)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "asahi-search-results-backdrop",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onSearchClose()))
        }))
      : _createCommentVNode("", true)
  ], 64))
}